module.exports = __webpack_public_path__ + "static/media/pexels-diego-pontes-2897130.624eb72d.jpg";